import * as types from '@/store/mutation-types'

const state = {
    mainMenu: '',
    enableChild: '',
    scrnDiv: '',
    // pageTitle: ''
}

const getters = {
    mainMenu: state => state.mainMenu,
    enableChild: state => state.enableChild,
    scrnDiv: state => state.scrnDiv,
    // pageTitle: state => state.pageTitle
}

const mutations = {
    [types.MAIN_MENU](state, value) {
        state.mainMenu = value;
    },
    [types.ENABLE_CHILD](state, value) {
        state.enableChild = value;
    },
    [types.SCRN_DIV](state, value) {
        state.scrnDiv = value;
    },
    // [types.PAGE_TITLE](state, value) {
    //     state.pageTitle = value;
    // },

}

export default {
    state,
    getters,
    mutations
}